import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb69f4b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kpi-grid" }
const _hoisted_2 = { class: "kpi-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Period", -1))
const _hoisted_4 = { class: "kpi-value" }
const _hoisted_5 = { class: "kpi-card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "NEEn,act", -1))
const _hoisted_7 = { class: "kpi-value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-unit" }, "kWh", -1))
const _hoisted_9 = {
  key: 0,
  class: "kpi-delta"
}
const _hoisted_10 = { class: "kpi-card" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "NEEn,deemed", -1))
const _hoisted_12 = { class: "kpi-value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-unit" }, "kWh", -1))
const _hoisted_14 = { class: "kpi-card" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Deemed − actual gap", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-unit" }, "kWh", -1))
const _hoisted_17 = {
  key: 0,
  class: "kpi-unit"
}
const _hoisted_18 = { class: "kpi-card" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "TPn", -1))
const _hoisted_20 = { class: "kpi-value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-unit" }, "SAR", -1))
const _hoisted_22 = {
  key: 0,
  class: "kpi-delta"
}
const _hoisted_23 = { class: "kpi-card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Invoice total (incl. VAT)", -1))
const _hoisted_25 = { class: "kpi-value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-unit" }, "SAR", -1))
const _hoisted_27 = { class: "kpi-card" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Avg PR / APR / PPR", -1))
const _hoisted_29 = { class: "kpi-value text-base" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-unit" }, "/", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-unit" }, "/", -1))
const _hoisted_32 = { class: "kpi-card" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Valid / invalid hours", -1))
const _hoisted_34 = { class: "kpi-value" }
const _hoisted_35 = { class: "text-green-500" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-secondary" }, " / ", -1))
const _hoisted_37 = { class: "text-orange-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PTag = _resolveComponent("PTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.kpis?.period_name || '—') + " ", 1),
          (_ctx.kpis?.period_status)
            ? (_openBlock(), _createBlock(_component_PTag, {
                key: 0,
                severity: _ctx.statusSeverity(_ctx.kpis.period_status),
                class: "ml-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.kpis.period_status), 1)
                ]),
                _: 1
              }, 8, ["severity"]))
            : _createCommentVNode("", true),
          (_ctx.kpis?.is_trial)
            ? (_openBlock(), _createBlock(_component_PTag, {
                key: 1,
                class: "ml-1",
                severity: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("trial")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.fmt(_ctx.kpis?.nee_n_act)) + " ", 1),
          _hoisted_8
        ]),
        (_ctx.kpis?.prev_nee_n_act != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " vs " + _toDisplayString(_ctx.kpis.prev_period_name) + ": " + _toDisplayString(_ctx.fmt(_ctx.kpis.prev_nee_n_act)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.fmt(_ctx.kpis?.nee_n_deemed)) + " ", 1),
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", {
          class: _normalizeClass(["kpi-value", _ctx.gapClass])
        }, [
          _createTextVNode(_toDisplayString(_ctx.fmt(_ctx.kpis?.nee_gap_kwh)) + " ", 1),
          _hoisted_16,
          (_ctx.kpis?.nee_gap_pct != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, " (" + _toDisplayString(_ctx.fmtSigned(_ctx.kpis.nee_gap_pct)) + "%) ", 1))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createTextVNode(_toDisplayString(_ctx.fmt(_ctx.kpis?.tpn)) + " ", 1),
          _hoisted_21
        ]),
        (_ctx.kpis?.prev_tpn != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, " vs " + _toDisplayString(_ctx.kpis.prev_period_name) + ": " + _toDisplayString(_ctx.fmt(_ctx.kpis.prev_tpn)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createTextVNode(_toDisplayString(_ctx.fmt(_ctx.kpis?.invoice_total)) + " ", 1),
          _hoisted_26
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createTextVNode(_toDisplayString(_ctx.fmtPr(_ctx.kpis?.avg_pr)) + " ", 1),
          _hoisted_30,
          _createTextVNode(" " + _toDisplayString(_ctx.fmtPr(_ctx.kpis?.avg_apr)) + " ", 1),
          _hoisted_31,
          _createTextVNode(" " + _toDisplayString(_ctx.fmtPr(_ctx.kpis?.avg_ppr)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.kpis?.valid_hours ?? '—'), 1),
          _hoisted_36,
          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.kpis?.invalid_hours ?? '—'), 1)
        ])
      ])
    ])
  ]))
}